module.exports = __webpack_public_path__ + "static/media/ocd_thumb_wide.0b302961.webp";